import { render } from "./OrgStructure.vue?vue&type=template&id=3d585ff2&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=3d585ff2&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=3d585ff2&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d585ff2"]])

export default __exports__